import {
    SETUP_APP,
    RESET_CART,
    START_ORDER,
    SET_ORDER_TYPE,
    SET_ORDER_TIP,
    SET_ITEM_TO_CART,
    SET_ITEM_TO_CONSTRUCTION,
    REMOVE_ITEM_FROM_CONSTRUCTION,
    SET_REMARK_TO_ORDER,
    SAVE_DELIVERY_INFO,
    CALC_FINAL_CHECK,
    REMOVE_ITEM_FROM_CART,
    CHECKOUT_RESOLVED,
    SET_BRANCH
} from '../actions/types';
import { getStorage, setStorage } from '../cache';

const cache = getStorage();

const INITIAL_CART = { orderType: 'takeaway', items: [], remarks: '' };

const INITIAL_STATE = {
    deliveryInfo: cache.deliveryInfo || null,
    cart: cache.cart || INITIAL_CART,
    cartDeadline: cache.cartDeadline || null,
    checkSummary: cache.checkSummary || { subtotal: 0, paymentAmount: 0 },
    orderConfirmation: cache.orderGuid ? { orderGuid: cache.orderGuid } : null,
    tableNumber: cache.tableNumber || null,
    requestedTipPercentage: cache.requestedTipPercentage || null,
    itemInConstruction: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_CART: {
            const cart = INITIAL_CART;
            setStorage({ cart });
            return { ...state, cart };
        }
        case SET_ORDER_TYPE: {
            const cart = { ...state.cart, orderType: action.payload };
            setStorage({ cart });
            return { ...state, cart };
        }
        case SET_ORDER_TIP: {
            setStorage({ requestedTipPercentage: action.payload });
            return { ...state, requestedTipPercentage: action.payload };
        }
        case START_ORDER: {
            const { cartDeadline } = action.payload;
            const cart = { ...state.cart, ...action.payload.cart };
            setStorage({ cart, cartDeadline });

            return { ...state, cart, cartDeadline };
        }
        case SET_ITEM_TO_CART: {
            if (!action.meta.replace) {
                action.payload.index = state.cart.items.length;
            }

            const items = action.meta.replace
                ? state.cart.items.map((item, index) => index === action.payload.index ? action.payload : item)
                : state.cart.items.concat(action.payload);

            const cart = { ...state.cart, items };

            setStorage({ cart });

            return {
                ...state,
                itemInConstruction: null,
                cart,
            };
        }
        case REMOVE_ITEM_FROM_CART: {
            const cart = {
                ...state.cart,
                items: state.cart.items.filter(item => item.index !== action.payload.index).map((item, index) => ({ ...item, index }))
            };

            setStorage({ cart });

            return { ...state, cart };
        }
        case SET_ITEM_TO_CONSTRUCTION:
            return { ...state, itemInConstruction: action.payload };
        case REMOVE_ITEM_FROM_CONSTRUCTION:
            return { ...state, itemInConstruction: null };
        case SAVE_DELIVERY_INFO:
            setStorage({ deliveryInfo: action.payload });
            return { ...state, deliveryInfo: action.payload };
        case CALC_FINAL_CHECK:
            setStorage({ checkSummary: action.payload });
            return { ...state, checkSummary: action.payload };
        case SET_REMARK_TO_ORDER:
            return { ...state, cart: { ...state.cart, remarks: action.payload } };
        case SET_BRANCH: {
            const cart = { ...INITIAL_CART, orderType: state.cart.orderType };
            return { ...state, cart };
        }
        case CHECKOUT_RESOLVED: {
            return { ...state, orderConfirmation: action.payload, cartDeadline: null };
        }
        case SETUP_APP:
            setStorage({ tableNumber: action.payload.tableNumber });
            return { ...state, tableNumber: action.payload.tableNumber };
        default:
            return state;
    }
};
